// ---------------------------------------------------------------------------
// Default agent used when no agent identity is available
// ---------------------------------------------------------------------------
export const DEFAULT_AGENT = {
    name: 'office',
    display_name: 'Assistant',
    color: '#585870',
    icon: 'fa-light fa-message-bot',
    short_description: ''
};
// ---------------------------------------------------------------------------
// Default cost object for locally-constructed envelopes
// ---------------------------------------------------------------------------
const DEFAULT_COST = {
    model_used: '',
    input_tokens: 0,
    output_tokens: 0,
    estimated_cost_usd: 0,
    tool_calls_count: 0
};
export function buildResponseEnvelope({ responseId, conversationId, turnNumber = 0, agent, blocks, suggestedActions = [], feedbackId = '', durationMs = 0, agentResponse = '' }) {
    return {
        response_id: responseId,
        conversation_id: conversationId,
        tenant_id: '',
        turn_number: turnNumber,
        agent: agent || DEFAULT_AGENT,
        blocks,
        suggested_actions: suggestedActions,
        feedback_id: feedbackId,
        cost: DEFAULT_COST,
        duration_ms: durationMs,
        created_at: new Date().toISOString(),
        agent_response: agentResponse,
        citations: [],
        deep_links: []
    };
}
// ---------------------------------------------------------------------------
// ChatMessage builders
// ---------------------------------------------------------------------------
export function buildAgentMessage(options) {
    const envelope = buildResponseEnvelope(options);
    return {
        id: options.id || options.responseId,
        role: 'agent',
        content: '',
        agent: options.agent || undefined,
        envelope,
        created_at: new Date().toISOString()
    };
}
export function buildUserMessage(content, fileAttachments) {
    return {
        id: `msg-${Date.now()}`,
        role: 'user',
        content,
        file_attachments: fileAttachments,
        created_at: new Date().toISOString()
    };
}
